<template>
     <!-- v-if="pageId==='1'"  -->

     
	<div   >
        <!-- class="consult_box" -->
 
        <!-- <el-button type="success" @click="consulting">在线咨询</el-button> -->
       

    </div>
    
	
</template> 

<script>



// const routes = [ 
 
//   // { path: '/', redirect:'/tools'},
//   {path:'/tools', component: ()=>import('@/components/toolsbox/cal.vue') ,name:"tools" },
//   // {path:'/tools/sound2txt', component: ()=>import('@/components/toolsbox/sound2txt/sound2txt.vue'),name:"sound2txt" },  
//   {path:'/tools/legalfee', component: ()=>import('@/components/functions/legalfee.vue') ,name:"legalfee" },
 

 
// ] 

// import VueRouter from 'vue-router' 
// const router = new VueRouter({
//   routes,
//   mode:'history'  
// })
 
	export default {
    name: 'consult', 
    // props: {
    // pageId: String
    // },
    // router,
    data() {
			return { 
		 
           
			}
    },
    methods:{
 
        consulting(){
            window.open('https://webim.bytedance.com/h5/normal/150697/3366acf84aad2c87/')
        }


 
    }
	}
</script>

<style scoped>
    .consult_box{
    position: fixed;
    /* background-color: #1b7bdb; */
    height: 285px;
    z-index: 2999;
    width: 160px;
    /* bottom: 0; */
    /* right: 30%; */
    right: 0;
    top:240px;
    border-radius: 5px;
    background-image: url(../../assets/images/ads/ad1.jpg)  ;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    /* border:1px solid rgb(164, 218, 40);  */
}
.minconsult_boxi_box p{
    font-size:14px;
    color:snow;
}


</style>
